import React from "react";
import PropTypes from "prop-types";
import { cn } from '../../utils/lib/utils';
import { Card, CardContent, CardHeader, CardTitle } from './card';
import { Tooltip } from './tooltip';

export function MetricCard({
  className,
  title,
  value,
  trend,
  icon: Icon,
  description,
  tooltip,
  ...props
}) {
  const isPositive = trend >= 0;

  return (
    <Card className={className} {...props}>
      <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
        <CardTitle className="text-sm font-medium">
          {title}
        </CardTitle>
        {Icon && (
          <div className="h-4 w-4 text-muted-foreground">
            <Icon className="h-4 w-4" />
          </div>
        )}
      </CardHeader>
      <CardContent>
        <div className="text-2xl font-bold">{value}</div>
        <Tooltip content={tooltip}>
          <div className="flex items-center space-x-2">
            <p className="text-xs text-muted-foreground">
              {description}
            </p>
            {trend !== undefined && (
              <div
                className={cn(
                  "flex items-center text-xs",
                  isPositive ? "text-green-600" : "text-red-600"
                )}
              >
                {isPositive ? "+" : ""}
                {trend}%
              </div>
            )}
          </div>
        </Tooltip>
      </CardContent>
    </Card>
  );
}

MetricCard.propTypes = {
  title: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  trend: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  icon: PropTypes.elementType,
  description: PropTypes.string,
  tooltip: PropTypes.string,
  className: PropTypes.string,
};
